import { Routes } from '@angular/router';
import { notLoggedInChild, userGuard } from './shared/guards/user.guard';

const pages = {
  landing: '',
  auth: 'auth',
  product: 'product',
  shop: 'shop',
  partsCatalog: 'parts-catalog',
  checkout: 'checkout',
  cart: 'cart',
  returns: 'returns',
  savedItems: 'saved-items',
  user: 'user',
  order: 'order',
  orderConfirmation: 'order-confirmation',
  notFound: '404',
  status: 'status',
  checkoutError: 'checkout-error',
  terms: 'terms-and-conditions',
  locations: 'locations',
  aboutUs: 'about-us',
  contactUs: 'contacts',
  delivery: 'delivery',
  buyingRules: 'buying-rules',
  career: 'career',
  disputes: 'disputes',
  faq: 'faq',
  guarantees: 'guarantees',
  payments: 'payments',
  privacyPolicy: 'privacy-policy',
};

const AuthRoutes = {
  login: 'login',
  register: 'register',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  verifyEmail: 'verify-email',
  verifyAccount: 'verify',
  authError: 'authentication-error',
  changeEmailAddress: 'change-email-address',
  authSuccess: 'authentication-success',
};

const ProfileRoutes = {
  savedItems: 'saved-items',
  orders: 'orders',
  addresses: 'addresses',
  account: 'account',
  deleteAccount: 'delete-account',
  order: 'order',
};

export const routes: Routes = [
  {
    path: pages.landing,
    loadComponent: () =>
      import('./routes/landing/landing.component').then(
        (m) => m.LandingComponent
      ),
    pathMatch: 'full',
  },
  {
    path: `${pages.partsCatalog}`,
    loadComponent: () =>
      import('./routes/parts-catalog/parts-catalog.component').then(
        (m) => m.PartsCatalogComponent
      ),
  },
  {
    path: `${pages.shop}/category/:slug/:productSlug`,
    loadComponent: () =>
      import('./routes/product/product.component').then(
        (m) => m.ProductComponent
      ),
  },
  {
    path: `${pages.shop}/category/:slug`,
    loadComponent: () =>
      import('./routes/shop/shop.component').then((m) => m.ShopComponent),
  },
  {
    path: `${pages.shop}/search`,
    loadComponent: () =>
      import('./routes/shop/shop.component').then((m) => m.ShopComponent),
  },

  {
    path: `${pages.product}/:productSlug`,
    loadComponent: () =>
      import('./routes/product/product.component').then(
        (m) => m.ProductComponent
      ),
  },
  {
    path: pages.status,
    loadComponent: () =>
      import('./routes/status/status.component').then((m) => m.StatusComponent),
  },
  {
    path: `${pages.delivery}`,
    loadComponent: () =>
      import('./routes/delivery/delivery.component').then(
        (m) => m.DeliveryComponent
      ),
  },
  {
    path: `${pages.buyingRules}`,
    loadComponent: () =>
      import('./routes/buying-rules/buying-rules.component').then(
        (m) => m.BuyingRulesComponent
      ),
  },
  {
    path: `${pages.career}`,
    loadComponent: () =>
      import('./routes/career/career.component').then((m) => m.CareerComponent),
  },
  {
    path: `${pages.disputes}`,
    loadComponent: () =>
      import('./routes/disputes/disputes.component').then(
        (m) => m.DisputesComponent
      ),
  },
  {
    path: `${pages.faq}`,
    loadComponent: () =>
      import('./routes/faq/faq.component').then((m) => m.FaqComponent),
  },
  {
    path: `${pages.guarantees}`,
    loadComponent: () =>
      import('./routes/guarantees/guarantees.component').then(
        (m) => m.GuaranteesComponent
      ),
  },
  {
    path: `${pages.payments}`,
    loadComponent: () =>
      import('./routes/payments/payments.component').then(
        (m) => m.PaymentsComponent
      ),
  },
  {
    path: `${pages.privacyPolicy}`,
    loadComponent: () =>
      import('./routes//privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: `${pages.aboutUs}`,
    loadComponent: () =>
      import('./routes/about-us/about-us.component').then(
        (m) => m.AboutUsComponent
      ),
  },
  {
    path: `${pages.contactUs}`,
    loadComponent: () =>
      import('./routes/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
  {
    path: `${pages.terms}`,
    loadComponent: () =>
      import(
        './routes/terms-and-conditions/terms-and-conditions.component'
      ).then((m) => m.TermsAndConditionsComponent),
  },
  {
    path: `${pages.locations}`,
    loadComponent: () =>
      import('./routes/locations/locations.component').then(
        (m) => m.LocationsComponent
      ),
  },
  {
    path: `${pages.checkoutError}`,
    loadComponent: () =>
      import('./routes/checkout-error/checkout-error.component').then(
        (m) => m.CheckoutErrorComponent
      ),
  },
  {
    path: `${pages.order}`,
    loadComponent: () =>
      import('./routes/order/order.component').then((m) => m.OrderComponent),
  },
  {
    path: `${pages.orderConfirmation}`,
    loadComponent: () =>
      import('./routes/order-confirmation/order-confirmation.component').then(
        (m) => m.OrderConfirmationComponent
      ),
  },
  {
    path: `${pages.cart}`,
    loadComponent: () =>
      import('./routes/cart/cart.component').then((m) => m.CartComponent),
  },
  {
    path: `${pages.savedItems}`,
    loadComponent: () =>
      import('./routes/saved-items/saved-items.component').then(
        (m) => m.SavedItemsComponent
      ),
    data: {
      pageInProfile: false,
    },
  },
  {
    path: `${pages.checkout}`,
    loadComponent: () =>
      import('./routes/checkout/checkout.component').then(
        (m) => m.CheckoutComponent
      ),
  },
  {
    path: `${pages.returns}`,
    loadComponent: () =>
      import('./routes/returns/returns.component').then(
        (m) => m.ReturnsComponent
      ),
  },
  {
    path: `${pages.user}`,
    loadComponent: () =>
      import('./routes/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    canActivate: [userGuard],
    children: [
      {
        path: ProfileRoutes.orders,
        loadComponent: () =>
          import('./routes/profile/routes/orders/orders.component').then(
            (m) => m.OrdersComponent
          ),
      },
      {
        path: `${ProfileRoutes.orders}/${ProfileRoutes.order}`,
        loadComponent: () =>
          import('./routes/order/order.component').then(
            (m) => m.OrderComponent
          ),
        data: {
          pageInProfile: true,
        },
      },
      {
        path: ProfileRoutes.account,
        loadComponent: () =>
          import('./routes/profile/routes/account/account.component').then(
            (m) => m.AccountComponent
          ),
      },
      {
        path: ProfileRoutes.addresses,
        loadComponent: () =>
          import('./routes/profile/routes/addresses/addresses.component').then(
            (m) => m.AddressesComponent
          ),
      },
      {
        path: `${ProfileRoutes.account}/${ProfileRoutes.deleteAccount}`,
        loadComponent: () =>
          import(
            './routes/profile/routes/delete-account/delete-account.component'
          ).then((m) => m.DeleteAccountComponent),
      },
      {
        path: ProfileRoutes.savedItems,
        loadComponent: () =>
          import('./routes/saved-items/saved-items.component').then(
            (m) => m.SavedItemsComponent
          ),
        data: {
          pageInProfile: true,
        },
      },
    ],
  },
  {
    path: `${pages.auth}`,
    loadComponent: () =>
      import('./routes/auth/auth.component').then((m) => m.AuthComponent),
    children: [
      {
        path: AuthRoutes.login,
        loadComponent: () =>
          import('./routes/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
        canActivate: [notLoggedInChild],
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: AuthRoutes.register,
        loadComponent: () =>
          import('./routes/auth/register/register.component').then(
            (m) => m.RegisterComponent
          ),
        canActivate: [notLoggedInChild],
        data: {
          breadcrumbs: true,
        },
      },

      {
        path: AuthRoutes.authError,
        loadComponent: () =>
          import('./routes/auth/auth-error/auth-error.component').then(
            (m) => m.AuthErrorComponent
          ),
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: AuthRoutes.authSuccess,
        loadComponent: () =>
          import('./routes/auth/auth-success/auth-success.component').then(
            (m) => m.AuthSuccessComponent
          ),
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: `${AuthRoutes.verifyEmail}/:email`,
        loadComponent: () =>
          import('./routes/auth/verify-email/verify-email.component').then(
            (m) => m.VerifyEmailComponent
          ),
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: `${AuthRoutes.verifyAccount}`,
        loadComponent: () =>
          import('./routes/auth/verify-account/verify-account.component').then(
            (m) => m.VerifyAccountComponent
          ),
        // canActivate: [notLoggedInChild],
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: `${AuthRoutes.changeEmailAddress}`,
        loadComponent: () =>
          import(
            './routes/auth/verify-change-email/verify-change-email.component'
          ).then((m) => m.VerifyChangeEmailComponent),
        // canActivate: [notLoggedInChild],
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: `${AuthRoutes.resetPassword}`,
        loadComponent: () =>
          import('./routes/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
        data: {
          breadcrumbs: true,
        },
      },
      {
        path: `${AuthRoutes.forgotPassword}`,
        loadComponent: () =>
          import('./routes/auth/forgot-psw/forgot-psw.component').then(
            (m) => m.ForgotPswComponent
          ),
        data: {
          breadcrumbs: true,
        },
      },
    ],
  },

  {
    path: ':vehicleType',
    children: [
      {
        path: pages.landing,
        loadComponent: () =>
          import('./routes/landing/landing.component').then(
            (m) => m.LandingComponent
          ),
        pathMatch: 'full',
      },
      {
        path: `${pages.partsCatalog}`,
        loadComponent: () =>
          import('./routes/parts-catalog/parts-catalog.component').then(
            (m) => m.PartsCatalogComponent
          ),
      },
      {
        path: `${pages.shop}/category/:slug/:productSlug`,
        loadComponent: () =>
          import('./routes/product/product.component').then(
            (m) => m.ProductComponent
          ),
      },
      {
        path: `${pages.shop}/category/:slug`,
        loadComponent: () =>
          import('./routes/shop/shop.component').then((m) => m.ShopComponent),
      },
      {
        path: `${pages.shop}/search`,
        loadComponent: () =>
          import('./routes/shop/shop.component').then((m) => m.ShopComponent),
      },

      {
        path: `${pages.product}/:productSlug`,
        loadComponent: () =>
          import('./routes/product/product.component').then(
            (m) => m.ProductComponent
          ),
      },
      {
        path: pages.notFound,
        loadComponent: () =>
          import('./routes/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./routes/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
      },
    ],
  },

  {
    path: pages.notFound,
    loadComponent: () =>
      import('./routes/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./routes/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },

  // {
  //  path: '**',
  //  redirectTo: `${VehicleType.Passenger}`
  //   },
];
